import { ao as $, ap as M, a as p, m as V, q as B, u as S, o as T, b as h, c as l, e as u, t as k, k as c, z as q, ay as F, g as w, G as I, x, j as C, n as R, an as z } from "./define-element-XpjsV6s1.js";
import { i as d } from "./utils-CMsllPx8.js";
import { _ as A } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const D = ["aria-invalid", "aria-describedby"], E = ["id"], G = {
  __name: "Textarea",
  props: /* @__PURE__ */ z({
    floating: {
      type: Boolean,
      default: !1
    },
    invalid: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(f) {
    const e = $(f, "modelValue"), o = "input-" + Math.random().toString(36).substring(2), i = f, g = M(), v = p(!1), s = p(!1), r = V(() => i.invalid ? !1 : v.value && g.required != null ? !d(e.value) : !0);
    function y() {
      d(e.value) && (s.value = !1);
    }
    function m() {
      d(e.value) || (s.value = !0);
    }
    B(
      () => e.value,
      () => {
        i.floating && m();
      }
    );
    const b = S("container");
    return T(() => {
      h(b.value), m();
    }), (t, a) => (l(), u("div", {
      ref: "container",
      class: R([
        "offset-input",
        t.$attrs.required ? "required" : "",
        r.value ? "" : "invalid",
        i.floating ? "floating" : "",
        s.value ? "is-floating" : ""
      ])
    }, [
      t.$attrs.label ? (l(), u("label", {
        key: 0,
        for: o
      }, k(t.$attrs.label), 1)) : c("", !0),
      q(w("textarea", I(t.$attrs, {
        id: o,
        "onUpdate:modelValue": a[0] || (a[0] = (n) => e.value = n),
        "aria-invalid": !r.value,
        "aria-describedby": r.value ? void 0 : `${o}-error`,
        onInput: a[1] || (a[1] = x((n) => v.value = !0, ["stop"])),
        onFocusin: a[2] || (a[2] = (n) => s.value = !0),
        onFocusout: y
      }), null, 16, D), [
        [F, e.value]
      ]),
      r.value ? c("", !0) : (l(), u("div", {
        key: 1,
        id: `${o}-error`,
        class: "error",
        role: "alert"
      }, "This field is required", 8, E)),
      C(t.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}, L = /* @__PURE__ */ A(G, [["__scopeId", "data-v-0d16e772"]]);
export {
  L as T
};
